
import { getLeadStatusHistory } from "@/services/leads/leadStatusService";

export const getStatusNotes = async (leadId: string): Promise<string> => {
  try {
    // Get the lead status history, which is already sorted by most recent first
    const statusHistory = await getLeadStatusHistory(leadId);
    
    // Return the notes from the most recent status change, or empty string if none exists
    if (statusHistory.length > 0 && statusHistory[0].notes) {
      return statusHistory[0].notes;
    }
    
    return ''; // Return empty string instead of error message
  } catch (error) {
    console.error('Error fetching status notes:', error);
    return ''; // Return empty string on error for clean CSV export
  }
};
